@if (showBackgroundContainer) {
    <ms-header [titleIcon]="titleIcon" [backgroundContainerConfig]="backgroundContainerConfig" [globalLinkConfig]="globalLinkConfig" />
}

@if (isLoaderVisible) {
    <ms-ghost-loader />
}

@if ((promotionTiles.length || tiles.length) && !isLoaderVisible) {
    <ms-scroll-adapter size="medium" [scrollSpeed]="scrollSpeed" [buttonSize]="36">
        <div class="center" [class.marquee-container-cards]="showBackgroundContainer" [class.cards]="!showBackgroundContainer">
            @for (promotion of promotionTiles; track $index) {
                <ds-card
                    noOverflow="true"
                    msThemedCard
                    surface="lowest"
                    class="marquee-card card"
                    [themeCardElevated]="themeElevated"
                    [border]="!hideCardBorder()"
                    [radius]="true"
                    [class.crm-promo-card-marquee]="hasTiles"
                    [class.crm-promo-card-banner]="!hasTiles"
                    [attr.data-index]="$index">
                    <ms-crm-promotion-banner [promotion]="promotion" [listIndex]="$index" [trackingSource]="promotionTrackingSource" />
                </ds-card>
            }
            @for (tile of tiles; track $index) {
                <ds-card
                    msThemedCard
                    noOverflow="true"
                    surface="lowest"
                    class="marquee-card card"
                    [border]="!hideCardBorder()"
                    [radius]="true"
                    [themeCardElevated]="themeElevated"
                    [attr.data-index]="$index"
                    [class.no-promotion-card]="getType(tilesWithFallbackMarketType[$index])"
                    [class.crm-promo-card]="!getType(tilesWithFallbackMarketType[$index])"
                    [class.crm-promo-card-marquee]="!getType(tilesWithFallbackMarketType[$index])"
                    [class.marquee-regular-card]="
                        getType(tilesWithFallbackMarketType[$index]) === 'Regular' && tilesWithFallbackMarketType[$index]?.marketType !== 'SixPack'
                    "
                    [class.six-pack]="tilesWithFallbackMarketType[$index]?.marketType === 'SixPack'"
                    [class.with-link]="getHasLinkClass(tilesWithFallbackMarketType[$index]) === 'with-link'"
                    [class.with-image]="getMarqueeImageClass(tilesWithFallbackMarketType[$index]) === 'with-image'"
                    [class.v2-marquee]="marqueeConfig.marqueeVariant === v2MarqueeVariant">
                    @if (isTile(tile)) {
                        @if (isTileType(tile, 'BuildABet')) {
                            <ms-betbuilder-card
                                [tile]="tile"
                                [page]="page"
                                [preventNavigation]="preventNavigation"
                                [trackingPosition]="tileIndex($index)"
                                (click)="track(tileIndex($index), tile)" />
                        } @else if (isTileType(tile, 'Regular')) {
                            @if (promotedFixtureIdsMap[getEvent(tile)]) {
                                <ms-promotion-badge />
                            }

                            @switch (tilesWithFallbackMarketType[$index].marketType) {
                                @case ('CorrectScore') {
                                    <ms-correct-score-card
                                        [tile]="tile"
                                        [page]="page"
                                        [preventNavigation]="preventNavigation"
                                        [backgroundImage]="tile.source?.imageUrl"
                                        [trackingPosition]="tileIndex($index)"
                                        (click)="track(tileIndex($index), tile)"
                                        (correctScoreFallbacktoRegularTile)="triggerFallbackTile($event)" />
                                }
                                @case ('DynamicCorrectScore') {
                                    <ms-correct-score-card
                                        [tile]="tile"
                                        [page]="page"
                                        [preventNavigation]="preventNavigation"
                                        [backgroundImage]="tile?.source?.imageUrl"
                                        [trackingPosition]="tileIndex($index)"
                                        (click)="track(tileIndex($index), tile)"
                                        (correctScoreFallbacktoRegularTile)="triggerFallbackTile($event)" />
                                }
                                @case ('SixPack') {
                                    <ms-six-pack-event
                                        [tile]="tile"
                                        [event]="tile.event"
                                        [page]="page"
                                        [textColor]="tile.source?.textColor"
                                        [backgroundImage]="tile.source?.imageUrl"
                                        [trackingPosition]="tileIndex($index)"
                                        (click)="track(tileIndex($index), tile)"
                                        (sixPackFallbacktoRegularTile)="triggerFallbackTile($event)" />
                                }
                                @default {
                                    <ms-highlights-regular-card
                                        [tile]="tile"
                                        [page]="page"
                                        [trackingPosition]="tileIndex($index)"
                                        [images]="tileImages[$index]"
                                        [preventNavigation]="preventNavigation"
                                        (click)="track(tileIndex($index), tile)"
                                        (regularToCorrectScoreFallbackTile)="triggerFallbackTile($event)" />
                                }
                            }
                        } @else if (isTileType(tile, 'Special')) {
                            <ms-highlights-special-card
                                [tile]="tile"
                                [page]="page"
                                [images]="tileImages[$index]"
                                [preventNavigation]="preventNavigation"
                                [trackingPosition]="tileIndex($index)"
                                (click)="track(tileIndex($index), tile)" />
                        }
                    } @else if (isPromotion(tile)) {
                        <ms-crm-promotion-banner [promotion]="tile" [listIndex]="tileIndex($index)" [trackingSource]="promotionTrackingSource" />
                    }
                </ds-card>
            }
        </div>
    </ms-scroll-adapter>
}
